import React, { useEffect } from "react";
import { useNewPopup } from "./useNewPopup";
import { useModal } from "common/hooks";
import { useDraggeblePopup } from "common/hooks/useDraggeblePopup";

const NewPopup = () => {
  const { popups, hidePopupToday, closePopup } = useNewPopup();
  const { modal } = useModal();

  const ids = popups
    .map((p) => p.id)
    .filter((id): id is number => id !== undefined);
  const { pointerDown, styleOf } = useDraggeblePopup(ids);

  // 팝업이 없거나 URL이 '/' 가 아니면 렌더링 안 함
  if (popups.length === 0 || window.location.pathname !== "/") {
    return null;
  }

  return (
    <>
      <div
        style={{
          position: "absolute",
          top: 100,
          left: 100,
          zIndex: 999,
        }}
      >
        {popups.map((item, idx) => {
          const imgSrc = item.imgRoute?.replace(
            process.env.REACT_APP_ASSET_PRESET,
            process.env.REACT_APP_ASSET_URL,
          );
          return (
            <div
              key={item.id}
              id="notice-modal-container"
              onPointerDown={pointerDown(item.id!)} // 팝업 id에 따라 드래그
              style={styleOf(item.id!)} // id별로 드래드한
              // style={{
              //   position: "absolute",
              //   top: `${idx * 30}px`,
              //   left: `${idx * 30}px`,
              //   boxShadow: "0 0 4px #d2d2d2",
              //   borderRadius: "8px",
              // }}
            >
              <div className="innerBox">
                <div
                  className="popup-content notice-img"
                  style={{
                    backgroundColor: "#fff",
                    maxHeight: "500px",
                  }}
                >
                  <img src={imgSrc} alt="팝업 이미지 미리보기" />
                </div>
                <div
                  className="btnArea"
                  style={{ justifyContent: "space-around" }}
                >
                  {item.linkUrl === "" ? (
                    <>
                      <div
                        className="cBtn"
                        onClick={() => hidePopupToday(item.id!)}
                      >
                        오늘 하루 보지 않기
                      </div>
                      <div
                        className="cBtn"
                        onClick={() => closePopup(item.id!)}
                      >
                        닫기
                      </div>
                    </>
                  ) : (
                    <>
                      <a
                        href={item.linkUrl}
                        target="_blank"
                        rel="noreferrer"
                        className="cBtn"
                        style={{
                          display: "block",
                          maxHeight: "500px",
                          textDecorationLine: "none",
                          color: "#fff",
                        }}
                      >
                        바로가기
                      </a>
                      <div
                        className="cBtn"
                        onClick={() => hidePopupToday(item.id!)}
                        style={{ flexBasis: "unset", width: "240px" }}
                      >
                        오늘 하루 보지 않기
                      </div>
                      <div
                        className="cBtn"
                        onClick={() => closePopup(item.id!)}
                      >
                        닫기
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default NewPopup;
